import { Link } from "react-router-dom";
import packageMetadata from "../package.json";

const APP_VERSION = packageMetadata.version;

export default function LegalFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="legal-footer">
      <div className="legal-footer__inner">
        <p className="legal-footer__disclaimer">
          Wizards of the Coast, Magic: The Gathering, and associated names and logos are trademarks of Wizards of the Coast LLC in the United States and other countries. Copyright 1993-{currentYear} Wizards of the Coast LLC. MyTradeFinder is an independent fan-made service and is not affiliated with, endorsed, sponsored, or specifically approved by Wizards of the Coast LLC.
        </p>
        <p className="legal-footer__disclaimer">
          Card prices and card data on this site are provided by Scryfall, and represent daily estimates provided by Cardmarket. Scryfall does not guarantee price information and recommends checking stores directly for final prices and details.
        </p>
        <div className="legal-footer__meta">
          <span>Copyright {currentYear} MyTradeFinder</span>
          <span className="legal-footer__separator">·</span>
          <Link to="/terms">Terms of Service</Link>
          <span className="legal-footer__separator">·</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span className="legal-footer__separator">·</span>
          <Link to="/cookies">Cookie Policy</Link>
          <span className="legal-footer__separator">·</span>
          <span>Version {APP_VERSION}</span>
        </div>
      </div>
    </footer>
  );
}